import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import * as FileSaver from "file-saver";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TipoDte } from "src/app/models/tipoDte";
import { ConfigMantenedorCesionario } from "./config-mantenedor-cesionario";
import { Cesionario } from "src/app/models/Cesion/Cesionario";
import { CesionarioFilter } from "src/app/models/Cesion/CesionarioFilter";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { CesionarioService } from "src/app/services/cesionario.service";
import { PermissionService } from "src/app/services/permission.service";
import { SortType } from "@swimlane/ngx-datatable";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
@Component({
   selector: "app-mantenedor-cesionario",
   templateUrl: "./mantenedor-cesionario.component.html",
   styleUrls: ["./mantenedor-cesionario.component.scss"],
})
export class MantenedorCesionarioComponent implements OnInit {
   SortType = SortType;
   public loading: boolean = false;
   public rowsMantenedor: Cesionario[] = [];
   public page: Page = new Page();
   private filter: CesionarioFilter = new CesionarioFilter();
   private addCesionarioModalRef: NgbModalRef;
   private editCesionarioModalRef: NgbModalRef;
   private showCesionarioModalRef: NgbModalRef;
   private asignCesionarioModalRef: NgbModalRef;
   public selectedCesionario: Cesionario = undefined;
   public emisorId: string;
   public configLocal = ConfigMantenedorCesionario;
   public componentStarted: boolean = false;
   @ViewChild("tableMobile") tableRef: any;
   private closeActionsHandler: any;
   constructor(private CesionarioService: CesionarioService, private ref: ChangeDetectorRef, private modalService: NgbModal, private tokenService: TokenStorageService, public utilities: UtilitiesService, public permissions: PermissionService, private localStorage: LocalStorageService,private sessionUserService: SessionUserService) {
      (this.emisorId = this.tokenService.getCompany()), (this.filter.activo = 1);
      this.filter.emisorId = this.emisorId;
   }

   toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
    
   
	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }


   ngOnInit(): void {
      this.sessionUserService.verificarSesionUsuario();
      this.setPage({ offset: 0 });
   }
   setPageSize() {
      //this.page.currentPageSize = this.page.page
      this.setPage({ offset: 0 });
   }
   setPage(pageInfo) {
      this.loading = true;
      this.page.pageNumber = pageInfo.offset;
      let localPage = JSON.parse(JSON.stringify(this.page));
      localPage.pageNumber += 1;
      this.CesionarioService.getDataByPage(this.filter, localPage)
         .subscribe(
            (result) => {
               this.loading = false;
               let rows = result.data as Cesionario[];
               this.rowsMantenedor = [...rows];
               this.rowsMantenedor.forEach((row) => {});
               this.setPageFromResponse(this.page, result);
               this.ref.detectChanges();
            },
            (error) => {
               this.loading = false;
               this.ref.detectChanges();
               Swal.fire({
                  icon: "error",
                  title: "Error en Lista Cesionarios",
                  text: "No fue posible obtener la lista de cesionarios disponibles, recargue la pagina." + this.utilities.setErrorMessageFromArray(error.error),
               });
            }
         )
         .add(() => {
            this.componentStarted = true;
         });
   }

   openAddCesionarioModal(modalRef) {
      this.addCesionarioModalRef = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
         centered: true,
      });
   }
   closeAddCesionarioModal() {
      this.addCesionarioModalRef.close();
   }
   openShowCesionarioModal(modalRef, row: Cesionario) {
      this.selectedCesionario = row;
      this.showCesionarioModalRef = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
         centered: true,
      });
   }
   closeShowCesionarioModal() {
      this.showCesionarioModalRef.close();
   }
   sendNewCesionario(event: Cesionario) {
      this.loading = true;
      this.CesionarioService.addCesionario(event).subscribe(
         (result) => {
            // let rows = JSON.parse(JSON.stringify(this.rowsMantenedor));
            // event.tipoPlantillaId = result.data;
            // rows.push(event);
            this.setPage({ offset: 0 });
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "success",
               title: "Cesionario Agregado",
               text: "Se ha agregado exitosamente al Cesionario " + event.razonSocial,
            });
            this.closeAddCesionarioModal();
         },
         (error) => {
            this.loading = false;
            this.ref.detectChanges();
            if (error.error.data) {
               Swal.fire({
                  icon: "info",
                  title: "Cesionario Existente",
                  text: "Ya existe un Cesionario con el rut " + event.rut + "-" + event.dv,
               });
            } else {
               Swal.fire({
                  icon: "error",
                  title: "Error al Agregar Cesionario",
                  text: "No se ha podido agregar al Cesionario " + event.razonSocial + ", intente nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
               });
            }
         }
      );
      // ).add(()=>{
      //   this.loading=false;
      //   this.ref.detectChanges();
      //   this.closeAddCesionarioModal();
      // });
   }

   openEditCesionarioModal(modalRef, row: Cesionario) {
      this.selectedCesionario = row;
      this.editCesionarioModalRef = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
         centered: true,
      });
   }

   closeEditCesionarioModal() {
      this.editCesionarioModalRef.close();
   }

   editCesionarioRequest(event: Cesionario) {
      this.loading = true;
      this.CesionarioService.updateCesionario(event).subscribe(
         (result) => {
            // let rows = JSON.parse(JSON.stringify(this.rowsMantenedor));
            // event.tipoPlantillaId = result.data;
            // rows.push(event);
            // this.ref.detectChanges();
            // this.rowsMantenedor = JSON.parse(JSON.stringify(rows)) as Cesionario[];
            this.setPage({ offset: 0 });
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "success",
               title: "Cesionario Actualizado",
               text: "Se ha actualizado exitosamente al Cesionario  " + event.razonSocial,
            });
            this.closeEditCesionarioModal();
         },
         (error) => {
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "error",
               title: "Error al Actualizar Cesionario",
               text: "No se ha podido actualizar al Cesionario " + event.razonSocial + ", intente nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
            });
         }
      );
      // ).add(()=>{
      //   this.loading=false;
      //   this.ref.detectChanges();
      //   this.closeEditCesionarioModal();
      // });
   }

   deactivateCesionario(row: Cesionario) {
      this.loading = true;
      this.CesionarioService.deactivateCesionario(row.cesionarioId).subscribe(
         (result) => {
            this.loading = false;
            // let currentRow = this.rowsMantenedor.find(plantilla => plantilla.tipoPlantillaId == row.tipoPlantillaId);
            // this.rowsMantenedor.splice(this.rowsMantenedor.indexOf(currentRow),1);
            this.setPage({ offset: 0 });
            this.ref.detectChanges();
            Swal.fire({
               icon: "success",
               title: "Cesionario Desactivado",
               text: "La Cesionario " + row.razonSocial + " fue desactivado exitosamente",
            });
         },
         (error) => {
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "error",
               title: "Error al Desactivar Cesionario",
               text: "No fue posible desactivar al Cesionario " + row.razonSocial + this.utilities.setErrorMessageFromArray(error.error),
            });
         }
      );
   }
   activateCesionario(row: Cesionario) {
      this.loading = true;
      this.CesionarioService.activateCesionario(row.cesionarioId).subscribe(
         (result) => {
            this.loading = false;
            // let currentRow = this.rowsMantenedor.find(plantilla => plantilla.tipoPlantillaId == row.tipoPlantillaId);
            // this.rowsMantenedor.splice(this.rowsMantenedor.indexOf(currentRow),1);
            this.setPage({ offset: 0 });
            this.ref.detectChanges();
            Swal.fire({
               icon: "success",
               title: "Cesionario Activado",
               text: "El Cesionario " + row.razonSocial + " fue activado exitosamente",
            });
         },
         (error) => {
            this.loading = false;
            this.ref.detectChanges();
            Swal.fire({
               icon: "error",
               title: "Error al Activar Cesionario",
               text: "No fue posible activar al Cesionario " + row.razonSocial + this.utilities.setErrorMessageFromArray(error.error),
            });
         }
      );
   }

   setPageFromResponse(currentPage: Page, data: PagedResponse<Cesionario>) {
      currentPage.pageSize = data.pageSize;
      currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
      currentPage.totalPages = data.totalPages;
      currentPage.totalElements = data.totalRecords;
   }

   popupCenter(url, title, w, h) {
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      const systemZoom = width / window.screen.availWidth;
      const left = (width - w) / 2 / systemZoom + dualScreenLeft;
      const top = (height - h) / 2 / systemZoom + dualScreenTop;
      const newWindow = window.open(
         url,
         title,
         `
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
      );
      if (window.focus) {
         newWindow.focus();
      }
   }

   searchElementsByFilter(event) {
      this.filter[event.criterio] = event.busqueda;
      this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
      this.filter.emisorId = this.emisorId;
      this.filter.activo = event.registroActivo ? 0 : 1;
      this.setPage({ offset: 0 });
   }

   exportToExcel() {
      this.getAllRowsByFilter(this.page, this.filter);
   }
   getAllRowsByFilter(currentPageRef: Page, currentFilter: CesionarioFilter) {
      let fullPage: Page = new Page();
      fullPage.pageSize = currentPageRef.totalElements;
      fullPage.pageNumber = 1;
      fullPage.totalElements = currentPageRef.totalElements;
      fullPage.totalPages = 1;
      this.loading = true;
      this.CesionarioService.getDataByPage(currentFilter, fullPage).subscribe(
         (result) => {
            let elements = result.data as Cesionario[];
            elements.forEach((row) => {});
            this.loading = false;
            this.ref.detectChanges();
            this.exportExcelData(elements);
         },
         (error) => {
            this.loading = false;
            this.ref.detectChanges();
            let msg = "";
            if (error.error.message) {
               msg += error.error.message;
            }
            Swal.fire({
               icon: "error",
               title: "Error al exportar",
               text: "No es posible exportar los datos. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(error.error),
            });
         },
         () => {
            this.loading = false;
            this.ref.detectChanges();
         }
      );
   }
   exportExcelData(arrayToExport: Array<Cesionario>): void {
      let arregloExportar = [];
      arrayToExport.forEach((row) => {
         let elementToExport = {};
         elementToExport["Rut"] = row.rutFormateado;
         elementToExport["Razón Social"] = row.razonSocial;
         elementToExport["Dirección"] = row.direccion;
         elementToExport["Correo"] = row.correo;
         elementToExport["fono"] = row.fono;
         arregloExportar.push(elementToExport);
      });
      this.utilities.exportAsExcelFile(arregloExportar, "Cesionario");
   }

   toggleExpandRow(row) {
      this.tableRef.rowDetail.toggleExpandRow(row);
   }
}
